<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="V_FinPaymentDue_Invoice"
                :filter_language="['BalanceMode_Name','Invoice_Status']"
                :filter_thousandth_puramount="['Total_Amount','Tax_Total_Amount','Net_Total_Amount','Vender_Net_Total_Amount','Vender_Remain_Amount','Remain_Amount']"
                :filter_date="['Invoice_Date','Payment_Date']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1196]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Audit_Year" :label="$t('getapi[3679]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Audit_Month" :label="$t('getapi[3680]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Total_Amount" :label="$t('getapi[3745]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Invoice_No" :label="$t('getapi[2992]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Invoice_Code" :label="$t('getapi[3681]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Invoice_type_name" :label="$t('getapi[3682]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Invoice_Date" :label="$t('getapi[3683]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Order_Type_Code" :label="$t('getapi[1976]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="BalanceMode_Name" :label="$t('getapi[1228]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Payment_Date" :label="$t('getapi[3686]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[3108]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Exchange_rate" :label="$t('getapi[3287]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[3690]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Create_Date" :label="$t('getapi[3691]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[742]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="buyer" :label="$t('getapi[1167]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Payment_period" :label="$t('getapi[1600]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Tax_code" :label="$t('getapi[3693]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1225]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Invoice_Status" :label="$t('getapi[3694]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Exchange_modify_person" :label="$t('getapi[3695]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Exchange_modify_date" :label="$t('getapi[3696]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Audit_Period" :label="$t('getapi[3697]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="InvoiceNumLst" :label="$t('getapi[7222]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Create_Year" :label="$t('getapi[3677]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Create_Mouth" :label="$t('getapi[3678]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Tax_Total_Amount" :label="$t('getapi[3704]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Net_Total_Amount" :label="$t('getapi[3701]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Net_Total_Amount" :label="$t('getapi[3702]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Remain_Amount" :label="$t('getapi[3689]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Remain_Amount" :label="$t('getapi[3688]')"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="V_FinPaymentDue_Invoice" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6607]')" queryData="V_FinPaymentDue_Invoice" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'3_finpaymentdue',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_finpaymentdue'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('V_FinPaymentDue_Invoice', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6607]"),this.$t("getapi[3836]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 220, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 220, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    default:
                        break;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_finpaymentdue',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'V_FinPaymentDue_Invoice');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Invoice/FinPaymentDueList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/Invoice/FinPaymentDueExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "V_FinPaymentDue_Invoice",
                    fromname: that.$t('getapi[6607]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
